import Swal from "sweetalert2";

export const success = (msg) => {
  Swal.fire("Éxito", msg, "success");
};

export const error = (msg) => {
  Swal.fire("Error", msg, "error");
};
